// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__dk9uc","notes":"Notes_notes__1PG-m","note":"Notes_note__3cWOk","markdown":"Notes_markdown__pF9-G"};